import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSurveyWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "monument",
	width: 15.207639,
	height: 17.251875,
	viewBox: "0 0 15.207639 17.251875",
	"sodipodi:docname": "esclamativo bianco.svg",
	"inkscape:version": "1.1.1 (3bf5ae0d25, 2021-09-20)",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { id: "defs8750" }),
		/* @__PURE__ */ _jsx("sodipodi:namedview", {
			id: "namedview8748",
			pagecolor: "#ffffff",
			bordercolor: "#666666",
			borderopacity: 1,
			"inkscape:pageshadow": 2,
			"inkscape:pageopacity": 0,
			"inkscape:pagecheckerboard": 0,
			showgrid: "false",
			"fit-margin-top": 0,
			"fit-margin-left": 0,
			"fit-margin-right": 0,
			"fit-margin-bottom": 0,
			"inkscape:zoom": 13.533333,
			"inkscape:cx": 17.807882,
			"inkscape:cy": 7.5738916,
			"inkscape:window-width": 1920,
			"inkscape:window-height": 1001,
			"inkscape:window-x": -9,
			"inkscape:window-y": -9,
			"inkscape:window-maximized": 1,
			"inkscape:current-layer": "monument"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "path11719-7",
			d: "m 4.4999995,2.2518758 -1.5,2.5 v 6.9999992 h 3 V 4.7518758 Z M 0,13.751875 v 3.5 h 8.9999995 v -3.5 l -1.5,-1.5 H 1.499999 Z",
			style: { fill: "#ffffff" }
		}),
		/* @__PURE__ */ _jsx("g", {
			"aria-label": "!",
			id: "text10021",
			style: {
				fontSize: "21.3333px",
				lineHeight: 1.25,
				fontFamily: "'Roboto Slab'",
				InkscapeFontSpecification: "'Roboto Slab'",
				textAlign: "center",
				textAnchor: "middle",
				fill: "#ffffff"
			},
			children: /* @__PURE__ */ _jsx("path", {
				d: "m 15.207639,13.656229 q 0,0.520832 -0.374999,0.885415 -0.364583,0.364583 -0.895832,0.364583 -0.5625,0 -0.947916,-0.354167 -0.374999,-0.364582 -0.374999,-0.895831 0,-0.5625 0.374999,-0.937499 0.375,-0.385416 0.916666,-0.385416 0.562499,0 0.927082,0.385416 0.374999,0.374999 0.374999,0.937499 z M 13.697225,10.197901 13.530558,9.6666515 Q 13.311809,9.0416525 13.020142,6.822906 12.738893,4.6041595 12.738893,3.0520786 12.738893,7.5437129e-8 13.936808,7.5437129e-8 q 1.166664,0 1.166664,2.968745324562871 0,2.4687461 -0.468749,5.0520753 l -0.281249,1.5937475 -0.166667,0.6041658 q -0.09375,0.322916 -0.281249,0.322916 -0.114583,0 -0.208333,-0.343749 z",
				style: {
					fontFamily: "'Gill Sans MT'",
					InkscapeFontSpecification: "'Gill Sans MT'",
					fill: "#ffffff"
				},
				id: "path24299"
			})
		})
	]
});
export default SvgSurveyWhite;
